{
  "nav": {
    "students": "Học viên",
    "subjects": "Môn học"
  },
  "list": {
    "title": "Học viên",
    "subtitle": "Quản lý học viên",
    "add": "Thêm học viên",
    "import": "Import Excel/CSV",
    "search": "Tìm theo tên học viên...",
    "name": "Học viên",
    "payer": "Người trả phí",
    "openPayer": "Mở hồ sơ người trả phí",
    "added": "Ngày thêm",
    "empty": "Chưa có học viên nào",
    "emptyTeachBody": "Thêm học viên đầu tiên hoặc nhập từ Excel.",
    "filterMissBody": "Thử bỏ bớt bộ lọc hoặc bật hiện học viên đã ngưng.",
    "emptyActiveOnly": "Không có học viên nào đang học.",
    "noResults": "Không tìm thấy học viên",
    "loading": "Đang tải...",
    "nickname": "Tên khác",
    "sortNewest": "Mới nhất",
    "sortOldest": "Cũ nhất",
    "sortName": "Tên A→Z",
    "sortPayer": "Theo người trả phí",
    "prev": "Trước",
    "next": "Sau",
    "pageOf": "Trang {{page}}/{{pages}} · {{total}} học viên",
    "filters": "Bộ lọc",
    "filterClear": "Xoá",
    "filterShowInactive": "Hiện cả học viên đã ngưng",
    "filterNoEnrollment": "Chưa có đăng ký",
    "filterNoEnrollmentExclusive": "Học viên chưa đăng ký thì chưa có môn học để lọc.",
    "filterNoSlot": "Chưa xếp lớp",
    "filterSubjects": "Môn học",
    "filterModes": "Hình thức học",
    "modeSessionMonthly": "Theo buổi",
    "modeSessionTerm": "Theo khoá",
    "modeMonthlyFlat": "Tháng cố định",
    "filterTags": "Thẻ",
    "subjects": "Môn học",
    "noEnrollmentChip": "Chưa có đăng ký",
    "noSlotChip": "Chưa xếp lớp",
    "khoaLeft": "Còn {{count}} buổi",
    "khoaOut": "Hết khoá",
    "addManual": "Thêm thủ công",
    "loadError": "Không tải được danh sách học viên. Thử lại sau.",
    "countSubtitle": "{{count}} học viên",
    "classesColumn": "Lớp",
    "classPartial": "({{joined}}/{{total}})",
    "filterClasses": "Lớp",
    "filterClassesSearch": "Tìm lớp…",
    "filterClassesEnded": "Đã kết thúc",
    "filterClassesEmpty": "Không có lớp nào phù hợp",
    "filterClassesFootnote": "Lớp đã kết thúc nằm cuối danh sách.",
    "appliedClassChip": "Lớp: {{name}}",
    "filterButtonShort": "Lọc",
    "filterButtonCount": "Lọc · {{count}}"
  },
  "status": {
    "ACTIVE": "Đang học",
    "INACTIVE": "Ngừng học"
  },
  "create": {
    "title": "Thêm học viên",
    "description": "Thêm một học viên và người trả phí",
    "selfPay": "Học viên tự trả (người lớn)",
    "payerSection": "Người trả phí",
    "existingPayer": "Chọn người trả phí có sẵn",
    "payerSearchPlaceholder": "Tìm theo tên hoặc SĐT...",
    "payerEmpty": "Không tìm thấy người trả phí",
    "newPayer": "hoặc tạo người trả phí mới",
    "payerName": "Tên người trả phí",
    "payerPhone": "Số điện thoại / Zalo",
    "payerEmail": "Email",
    "dupPayerWarning": "SĐT này đã có người trả phí {{name}}, dùng lại?",
    "cancel": "Huỷ",
    "submit": "Thêm",
    "submitting": "Đang lưu...",
    "tags": "Thẻ phân loại"
  },
  "fields": {
    "name": "Họ và tên",
    "namePlaceholder": "VD: Nguyễn Văn An",
    "nickname": "Tên thường gọi",
    "nicknamePlaceholder": "VD: Bơ",
    "dob": "Ngày sinh",
    "gender": "Giới tính",
    "genderUnspecified": "(Chưa chọn)",
    "genderMale": "Nam",
    "genderFemale": "Nữ"
  },
  "detail": {
    "back": "Quay lại",
    "payer": "Người trả phí",
    "identityBadge": "Học viên",
    "nickname": "Tên thường gọi",
    "dob": "Ngày sinh",
    "notes": "Ghi chú",
    "enrollments": "Đăng ký học",
    "addEnrollment": "Thêm đăng ký",
    "viewMonthAttendance": "Xem điểm danh tháng này",
    "activity": {
      "title": "Hoạt động",
      "empty": "Chưa có hoạt động nào.",
      "viewAll": "Xem tất cả hoạt động",
      "orgLog": "Xem toàn bộ nhật ký của lớp"
    },
    "notFound": "Không tìm thấy học viên",
    "emptyEnrollmentsTitle": "Chưa có đăng ký học nào",
    "emptyEnrollmentsBody": "Thêm đăng ký để xếp lớp và bắt đầu tính học phí.",
    "actions": {
      "menu": "Thao tác",
      "deactivate": "Ngừng học viên",
      "deactivateSuccess": "Đã ngừng học viên",
      "deactivateConfirmTitle": "Ngừng học viên này?",
      "deactivateConfirmDescription": "Hành động này sẽ:",
      "deactivateBullet1": "Kết thúc tất cả đăng ký học đang hoạt động của học viên",
      "deactivateBullet2": "Gỡ học viên khỏi mọi xếp lớp và suất học sắp tới",
      "deactivateBullet3": "Vẫn giữ lịch sử học phí đã phát sinh",
      "reactivate": "Kích hoạt lại",
      "reactivateSuccess": "Đã kích hoạt lại học viên",
      "delete": "Xoá học viên",
      "deleteSuccess": "Đã xoá học viên",
      "deleteConfirmTitle": "Xoá học viên này?",
      "deleteConfirmDescription": "Thao tác này không thể hoàn tác. Nếu học viên đã phát sinh học phí, hệ thống sẽ từ chối và đề nghị dùng \"Ngừng học viên\" thay thế.",
      "cancel": "Huỷ",
      "confirm": "Xác nhận"
    },
    "editDialog": {
      "title": "Sửa học viên",
      "name": "Họ và tên",
      "nickname": "Tên thường gọi",
      "dob": "Ngày sinh",
      "payer": "Người trả phí",
      "notes": "Ghi chú",
      "tags": "Thẻ",
      "success": "Đã cập nhật học viên",
      "payerReassignNotice": "Học viên còn {{count}} hoá đơn chưa trả, các hoá đơn cũ vẫn thuộc người trả phí cũ.",
      "submit": "Lưu",
      "submitting": "Đang lưu...",
      "cancel": "Huỷ"
    },
    "added": "Thêm ngày",
    "age": "{{count}} tuổi"
  },
  "popover": {
    "payer": "Người trả phí",
    "gender": "Giới tính",
    "dob": "Ngày sinh",
    "openProfile": "Mở trang học viên",
    "loadError": "Không tải được thông tin học viên."
  },
  "enrollment": {
    "monthlyBillingHint": "Thu học phí qua Chốt sổ hàng tháng",
    "notAssignedBadge": "Chưa xếp lớp",
    "title": "Thêm đăng ký học",
    "subject": "Môn học",
    "mode": {
      "label": "Hình thức học",
      "recommended": "Khuyên dùng",
      "SESSION_MONTHLY": {
        "label": "Theo buổi",
        "desc": "Đếm buổi trong tháng, cuối tháng chốt sổ ra hoá đơn. Phổ biến nhất."
      },
      "SESSION_TERM": {
        "label": "Theo khoá",
        "desc": "Đóng trước một khoá N buổi; hết khoá thì gia hạn."
      },
      "MONTHLY_FLAT": {
        "label": "Tháng cố định",
        "desc": "Một khoản cố định mỗi tháng, không phụ thuộc số buổi có mặt."
      }
    },
    "ratePerSession": "Học phí mỗi buổi (đ)",
    "monthlyRate": "Học phí mỗi tháng (đ)",
    "chargeAbsent": "Tính tiền buổi vắng không phép",
    "termSize": "Số buổi trong khoá",
    "cancel": "Huỷ",
    "submit": "Thêm",
    "submitting": "Đang lưu...",
    "statusPaused": "Tạm dừng",
    "statusEnded": "Đã kết thúc",
    "startDate": "Bắt đầu {{date}}",
    "termProgress": "Đã học {{consumed}}/{{termSize}} buổi khoá này",
    "monthlyProgress": "Đã học {{count}} buổi",
    "termRef": "Khoá {{size}} buổi",
    "termRefWithLabel": "Khoá {{size}} buổi ({{label}})",
    "actions": {
      "menu": "Thao tác",
      "pause": "Tạm dừng",
      "pauseSuccess": "Đã tạm dừng đăng ký",
      "resume": "Tiếp tục học",
      "resumeSuccess": "Đã tiếp tục học",
      "end": "Kết thúc khóa",
      "endSuccess": "Đã kết thúc khóa học",
      "pauseConfirmTitle": "Tạm dừng đăng ký này?",
      "pauseConfirmDescription": "Xếp lớp của học viên vẫn được bảo lưu, nhưng học viên sẽ không xuất hiện trong các suất học sắp tới. Bạn có thể cho học lại bất cứ lúc nào.",
      "endConfirmTitle": "Kết thúc khóa học này?",
      "endConfirmDescription": "Đăng ký sẽ dừng vĩnh viễn:",
      "endBullet1": "Gỡ học viên khỏi xếp lớp và các suất học sắp tới",
      "endBullet2": "Chốt học phí kỳ hiện tại lần cuối ở lượt Chốt sổ tiếp theo",
      "endBullet3": "Nếu học lại sau này sẽ cần xếp lớp lại",
      "editRate": "Sửa học phí",
      "delete": "Xoá đăng ký",
      "deleteConfirmTitle": "Xoá đăng ký này?",
      "deleteConfirmDescription": "Thao tác này không thể hoàn tác. Nếu đăng ký đã phát sinh học phí, hệ thống sẽ từ chối và đề nghị dùng \"Kết thúc khóa\" thay thế.",
      "confirm": "Xác nhận",
      "cancel": "Huỷ"
    },
    "editRateDialog": {
      "title": "Sửa cách tính học phí",
      "description": "Áp dụng cho mọi thứ chưa xuất hoá đơn, kể cả tháng bạn chưa chốt. Kỳ đã chốt không đổi. Nếu muốn tháng chưa chốt vẫn theo luật cũ, hãy chốt tháng đó trước rồi quay lại đổi.",
      "chargeAbsentLabel": "Tính tiền buổi vắng không phép",
      "chargeAbsentTermHint": "Đăng ký theo khoá: đổi giữa khoá sẽ đếm lại toàn bộ khoá đang chạy, nên khoá có thể hết sớm hơn.",
      "success": "Đã cập nhật học phí",
      "submit": "Lưu",
      "submitting": "Đang lưu...",
      "cancel": "Huỷ"
    }
  },
  "term": {
    "notStarted": "Chưa bắt đầu khóa",
    "start": "Bắt đầu khóa",
    "renew": "Gia hạn khóa",
    "startDateLabel": "Ngày bắt đầu",
    "startConfirmTitle": "Bắt đầu khóa mới?",
    "startConfirmDescription": "Hệ thống sẽ tạo hoá đơn thu trước học phí cho cả khóa. Bạn có chắc chắn muốn bắt đầu?",
    "renewConfirmTitle": "Gia hạn khóa?",
    "renewConfirmDescription": "Hệ thống sẽ đối soát khóa hiện tại và tạo hoá đơn thu trước cho khóa tiếp theo. Bạn có chắc chắn muốn gia hạn?",
    "confirm": "Xác nhận",
    "cancel": "Huỷ",
    "khoa": {
      "badgeNearlyOut": "Còn {{count}} buổi khoá",
      "badgeOut": "Hết khoá",
      "consequenceNearlyOut": "Còn {{count}} buổi, nhắc phụ huynh đóng học phí trước khi hết buổi.",
      "consequenceOut": "Đã dùng hết khoá, thu học phí ngay để buổi tới không dạy chịu."
    }
  },
  "subjects": {
    "title": "Môn học",
    "subtitle": "Danh mục môn học, học phí mặc định và sườn nhận xét buổi học",
    "add": "Thêm môn",
    "name": "Tên môn",
    "perSession": "đ/buổi",
    "perMonth": "đ/tháng",
    "defaultRate": "Học phí mặc định / buổi (đ)",
    "defaultMonthlyRate": "Học phí mặc định / tháng (đ)",
    "empty": "Chưa có môn học nào",
    "emptyBody": "Môn học quyết định giá mỗi buổi hoặc mỗi tháng, hoá đơn tính từ đây.",
    "create": "Thêm môn học",
    "edit": "Sửa môn học",
    "delete": "Xoá môn học",
    "cancel": "Huỷ",
    "submit": "Lưu",
    "menu": "Thao tác",
    "editDialog": {
      "title": "Sửa môn học",
      "name": "Tên môn",
      "defaultRate": "Giá mặc định / buổi (đ)",
      "defaultMonthlyRate": "Giá mặc định / tháng (đ)",
      "rateHint": "Chỉ áp dụng cho đăng ký mới, không đổi đăng ký đã có",
      "success": "Đã cập nhật môn học",
      "submit": "Lưu",
      "submitting": "Đang lưu...",
      "cancel": "Huỷ"
    },
    "deleteConfirm": {
      "title": "Xoá môn học này?",
      "description": "Thao tác này không thể hoàn tác. Không thể xoá môn đang có học viên đăng ký.",
      "confirm": "Xác nhận",
      "cancel": "Huỷ"
    },
    "detail": {
      "students": "Học viên đang học",
      "empty": "Chưa có học viên nào học môn này",
      "notFound": "Không tìm thấy môn học",
      "emptyBody": "Học viên xuất hiện ở đây khi bạn thêm đăng ký môn này cho họ."
    },
    "createDesc": "Môn học quyết định giá mỗi buổi hoặc mỗi tháng, hoá đơn tính từ đây.",
    "rateCol": "Học phí / buổi",
    "monthlyRateCol": "Học phí / tháng",
    "templateCol": "Sườn nhận xét",
    "templateNone": "Chưa có",
    "templateCustom": "Tự tạo"
  }
}
